export enum WorkforceUnitEnum {
  PERCENTAGE = 'percentage',
  FLAT = 'flat',
}
